/* eslint-disable react/prop-types */
import React from 'react'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import TextInput from '../common/form/TextInput'
import TextAreaInput from '../common/form/TextAreaInput'
import MyStatefulEditor from '../common/form/MyStatefulEditor'

import Select from 'react-select'
// import 'react-select/dist/react-select.css';
import '../../assets/styles/components/activity/actions/AnnoucementFormMobile.scss'
import Toggle from '../common/Toggle'

const selectInputFile = () => {
  document.getElementById('input-photo-upload').click()
}


const displayImageInput = (selectInputFile, inputFileSrc) => {
  if (inputFileSrc) {
    return (
      <Link className='imageSelect' onClick={selectInputFile}>
        <div className='center-cropped' style={{ backgroundImage: 'url(' + inputFileSrc + ')' }}/>
      </Link>
    )
  } else {
    return (
      <Link className='imageSelect' onClick={selectInputFile}> <i className='fa fa-camera' aria-hidden='true'></i> </Link>
    )
  }

}

class AnnouncementForm extends React.Component {
  constructor(props, context) {
    super(props, context)
    const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1

    this.state = {
      courses: [],
      uploadPhotoName: '',
      uploadPhotoFile: '',
      uploadPhotoSrc: '',
      description: '',
      sendEmail: false,
      subject: '',
      message: '',
      content: '',
      isSafari: isSafari,
      isWeb: this.props.web ? this.props.web : false,
    }

    this.onSelectAll = this.onSelectAll.bind(this)
    this.onEmailToggle = this.onEmailToggle.bind(this)
    this.onSelectOption = this.onSelectOption.bind(this)
    this.onChangeSubject = this.onChangeSubject.bind(this)
    this.onChangeMessage = this.onChangeMessage.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.renderEditor = this.renderEditor.bind(this)
    this.handlePhotoInputChange = this.handlePhotoInputChange.bind(this)
  }

  UNSAFE_componentWillMount() {
    if (this.props.sendEmail) { this.setState({ sendEmail: true }) }
  }

  onSelectOption(optionsSelected) {
    this.setState({ courses: optionsSelected })
  }

  onSelectAll() {
    this.setState({ courses: this.props.courseOptions })
  }

  onEmailToggle(_event) {
    this.setState({ sendEmail: !this.state.sendEmail })
  }

  onChangeSubject(event) {
    this.setState({ subject: event.target.value })
  }

  onChangeMessage(event) {
    this.setState({ message: event.target.value })
  }

  handleStatefulEditorChange = htmlString => {
    this.setState({
      message: htmlString,
    })
  }

  handlePhotoInputChange(changeEvent){
    this.setState({
      uploadPhotoName: changeEvent.target.value,
      uploadPhotoFile: changeEvent.target.files[0],
    })
    const reader = new window.FileReader()
    const page = this
    reader.onload = function (e) {
      page.setState({
        uploadPhotoSrc: e.target.result,
      })
    }
    reader.readAsDataURL(changeEvent.target.files[0])
  }

  submitForm(event) {
    event.preventDefault()
    this.props.handleSubmit(this.state)
  }

  renderEditor(){
    const { t } = this.props
    if (this.state.isSafari){
      return (<TextAreaInput
        name='Message'
        type='text'
        rows='3'
        label=''
        onChange={this.onChangeMessage}
        placeholder={t('announcements.form.enterYourMessage')}
        value={this.state.message}/>)
    } else {
      return (<MyStatefulEditor
        name='content'
        content={this.state.message}
        onChange={this.handleStatefulEditorChange} />)
    }
  }

  render() {
    const { t } = this.props
    return (
      <form id='announcement-form' className='form-container announcement-form-mobile'>
        { !this.state.isWeb ?
          <div className='col-12'>
            <div id='basicFormUploadImageThumb' className='text-center mx-auto'>
              {displayImageInput(selectInputFile, this.state.uploadPhotoSrc)}
              <div className='col hide'>
                <TextInput
                  name={''}
                  id={'input-photo-upload'}
                  type={'file'}
                  accept={'image/*'}
                  className={'form-control-file photoInput'}
                  onChange={this.handlePhotoInputChange}
                  placeholder={t('announcements.form.addDifferentPhoto')}
                  value={this.state.uploadPhotoName}
                  error={''} />
              </div>
            </div>
          </div> : null }
        <label className='first-label'>{t('announcements.form.to')}</label>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
        <span id='select-all-courses'
          onClick={this.onSelectAll}
        >{t('announcements.common.selectAll')}</span>
        <Select
          multi
          name='form-field-name'
          value={this.state.courses}
          options={this.props.courseOptions}
          placeholder={t('announcements.form.selectCourses')}
          onChange={this.onSelectOption}
          className='course-select-input'/>

        <label>{t('announcements.form.subject')}</label>
        <TextInput
          name='Subject'
          type='text'
          label=''
          onChange={this.onChangeSubject}
          placeholder={t('announcements.form.subject')}
          value={this.state.subject}/>

        <label>{t('announcements.form.message')}</label>
        {!this.state.isWeb
          ?
          <TextAreaInput
            name='Message'
            type='text'
            rows='3'
            label=''
            onChange={this.onChangeMessage}
            placeholder={t('announcements.form.message')}
            value={this.state.message}/>
          :
          this.renderEditor()
        }

        <label id='email-toggle-label' htmlFor='email-toggle'>{t('announcements.form.alsoSendAsEmail')}</label>
        <Toggle
          id='email-toggle'
          className='orange-bg'
          defaultChecked={this.state.sendEmail}
          icons={false}
          onChange={this.onEmailToggle} />
        <button
          id='submit-btn'
          type='submit'
          className='btn btn-block'
          onClick={this.submitForm}
          disabled={this.props.loader}
        >{this.props.loader ? t('announcements.form.sendingEmail') : t('common.action.sendEmail')}</button>
      </form>
    )
  }
}

export default withTranslation()(AnnouncementForm)
